/* Find Your Vibe quiz. Vanilla JS. Data comes from the inline JSON in sections/vibe-quiz.liquid.
   Scoring (SPEC 3.3):
   score = sum_liked( sum_lines w[line]*has(line) / sum_lines w ) + 0.5*noteHits(liked)
         - 0.6*( same for disliked ) */
(function () {
  'use strict';

  var root = document.querySelector('[data-vibe-quiz]');
  if (!root) return;

  var dataEl = root.querySelector('[data-vibe-data]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var VIBES = DATA.vibes;
  var LINE_IDS = DATA.lines;
  var VIBE_BY_ID = {};
  VIBES.forEach(function (v) { VIBE_BY_ID[v.id] = v; });

  var SHOW = 12;
  var THRESHOLD = 80;
  var LEAVE_MS = 340;

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var screens = {
    intro: $('[data-vq-screen="intro"]'),
    cards: $('[data-vq-screen="cards"]'),
    results: $('[data-vq-screen="results"]')
  };
  var stackEl = $('[data-vq-stack]');
  var progressText = $('[data-vq-progress-text]');
  var progressFill = $('[data-vq-progress-fill]');
  var undoBtn = $('[data-vq-undo]');
  var gridEl = $('[data-vq-grid]');
  var poolEl = $('[data-vq-pool]');
  var chipsEl = $('[data-vq-liked-chips]');
  var copiedEl = $('[data-vq-copied]');

  /* ---------------- Products (from the hidden pool) ---------------- */
  function stripAccents(s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  function canonLine(token) {
    var t = stripAccents(token).trim();
    if (!t) return null;
    if (LINE_IDS.indexOf(t) !== -1) return t;
    var head = t.split('-')[0];
    for (var i = 0; i < LINE_IDS.length; i++) {
      if (LINE_IDS[i].split('-')[0] === head) return LINE_IDS[i];
    }
    return null;
  }
  var PRODUCTS = [].slice.call(poolEl.children).map(function (el) {
    var lines = {};
    (el.getAttribute('data-lines') || '').split(',').forEach(function (tok) {
      var id = canonLine(tok);
      if (id) lines[id] = true;
    });
    var rating = parseFloat(el.getAttribute('data-rating'));
    return {
      el: el,
      title: el.getAttribute('data-title') || '',
      lines: lines,
      notes: stripAccents(el.getAttribute('data-notes') || ''),
      rating: isNaN(rating) ? 0 : rating,
      available: el.getAttribute('data-available') === 'true',
      available30: el.getAttribute('data-available-30') === 'true'
    };
  });

  /* ---------------- Scoring ---------------- */
  function lineScore(vibe, product) {
    var total = 0, hit = 0, k;
    for (k in vibe.weights) {
      total += vibe.weights[k];
      if (product.lines[k]) hit += vibe.weights[k];
    }
    return total ? hit / total : 0;
  }
  function noteHits(vibe, product) {
    var hits = 0;
    vibe.notes.forEach(function (kw) {
      var re = new RegExp('\\b' + kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (re.test(product.notes)) hits += 1;
    });
    return hits;
  }
  function scoreProduct(product, liked, disliked) {
    var s = 0;
    liked.forEach(function (v) { s += lineScore(v, product) + 0.5 * noteHits(v, product); });
    disliked.forEach(function (v) { s -= 0.6 * (lineScore(v, product) + 0.5 * noteHits(v, product)); });
    return s;
  }
  function pickWinners(likedIds, noIds) {
    var liked = likedIds.map(function (id) { return VIBE_BY_ID[id]; }).filter(Boolean);
    var disliked = noIds.map(function (id) { return VIBE_BY_ID[id]; }).filter(Boolean);
    var ranked = PRODUCTS.filter(function (p) { return p.available; }).map(function (p) {
      return { p: p, score: scoreProduct(p, liked, disliked) };
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (b.p.rating !== a.p.rating) return b.p.rating - a.p.rating;
      return a.p.title.localeCompare(b.p.title);
    });
    var winners = ranked.filter(function (r) { return r.p.available30; }).slice(0, 4);
    if (winners.length < 4) {
      ranked.forEach(function (r) {
        if (winners.length < 4 && winners.indexOf(r) === -1) winners.push(r);
      });
    }
    return winners.map(function (r) { return r.p; });
  }

  /* ---------------- Sampling: 12 of 20, every line covered ---------------- */
  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function sampleDeck(seed) {
    var rand = mulberry32(seed);
    var order = VIBES.slice();
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
    }
    var deck = order.slice(0, SHOW);
    var rest = order.slice(SHOW);
    function coverage(list) {
      var c = {};
      list.forEach(function (v) { for (var k in v.weights) c[k] = (c[k] || 0) + 1; });
      return c;
    }
    var guard = 0;
    while (guard++ < 20) {
      var cov = coverage(deck);
      var missing = LINE_IDS.filter(function (l) { return !cov[l]; });
      if (!missing.length) break;
      var need = missing[0];
      var candIdx = -1;
      for (var r = 0; r < rest.length; r++) { if (rest[r].weights[need]) { candIdx = r; break; } }
      if (candIdx === -1) break;
      /* drop the deck card whose every line is still covered by another card */
      var dropIdx = -1;
      for (var d = 0; d < deck.length; d++) {
        var ok = true;
        for (var k in deck[d].weights) { if (cov[k] < 2) { ok = false; break; } }
        if (ok) { dropIdx = d; break; }
      }
      if (dropIdx === -1) dropIdx = deck.length - 1;
      var swapped = deck[dropIdx];
      deck[dropIdx] = rest[candIdx];
      rest[candIdx] = swapped;
    }
    return deck;
  }

  /* ---------------- State ---------------- */
  var state = { deck: [], idx: 0, answers: [], variant: 0, topEl: null, nextEl: null, busy: false };

  function showScreen(name) {
    Object.keys(screens).forEach(function (k) {
      if (screens[k]) screens[k].hidden = (k !== name);
    });
    try { root.scrollIntoView({ block: 'start', behavior: 'auto' }); } catch (e) { /* no-op */ }
  }

  function imageSrc(vibe, variant) {
    return vibe.img[variant] || vibe.img[0];
  }
  function preload(i) {
    var v = state.deck[i];
    if (!v) return;
    var im = new Image();
    im.src = imageSrc(v, state.variant);
  }
  function buildCard(vibe) {
    var card = document.createElement('div');
    card.className = 'vq-card';
    card.setAttribute('data-vibe', vibe.id);
    var img = document.createElement('img');
    img.alt = vibe.title;
    img.decoding = 'async';
    img.draggable = false;
    img.src = imageSrc(vibe, state.variant);
    img.onerror = function () {
      if (img.src !== vibe.img[0]) { img.onerror = null; img.src = vibe.img[0]; }
    };
    card.appendChild(img);
    var yes = document.createElement('span'); yes.className = 'vq-stamp vq-stamp--yes'; yes.textContent = 'Yes';
    var no = document.createElement('span'); no.className = 'vq-stamp vq-stamp--no'; no.textContent = 'No';
    card.appendChild(yes); card.appendChild(no);
    var cap = document.createElement('div');
    cap.className = 'vq-card__caption';
    var t = document.createElement('p'); t.className = 'vq-card__title'; t.textContent = vibe.title;
    var l = document.createElement('p'); l.className = 'vq-card__line'; l.textContent = vibe.caption;
    cap.appendChild(t); cap.appendChild(l);
    card.appendChild(cap);
    return card;
  }

  function updateProgress() {
    var n = Math.min(state.idx + 1, state.deck.length);
    progressText.textContent = n + ' of ' + state.deck.length;
    progressFill.style.width = (state.idx / state.deck.length * 100) + '%';
    undoBtn.hidden = state.answers.length === 0;
  }

  /* Render the stack fresh for the current index (used at start and after undo) */
  function renderStack() {
    stackEl.innerHTML = '';
    state.topEl = null; state.nextEl = null;
    var cur = state.deck[state.idx];
    if (!cur) return;
    var next = state.deck[state.idx + 1];
    if (next) {
      state.nextEl = buildCard(next);
      state.nextEl.classList.add('vq-card--next');
      stackEl.appendChild(state.nextEl);
    }
    state.topEl = buildCard(cur);
    stackEl.appendChild(state.topEl);
    preload(state.idx + 1); preload(state.idx + 2);
    updateProgress();
  }

  function leave(el, dir) {
    el.classList.remove('is-dragging');
    el.classList.add('is-leaving');
    el.style.transform = 'translateX(' + (dir * 140) + '%) rotate(' + (dir * 22) + 'deg)';
    el.style.opacity = '0';
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, LEAVE_MS);
  }

  function answer(yes) {
    if (state.busy || !state.topEl) return;
    var vibe = state.deck[state.idx];
    state.answers.push({ id: vibe.id, yes: yes });
    leave(state.topEl, yes ? 1 : -1);
    state.idx += 1;
    if (state.idx >= state.deck.length) {
      state.busy = true;
      setTimeout(function () { state.busy = false; finish(); }, LEAVE_MS);
      return;
    }
    /* promote next, add a new "next" underneath */
    state.topEl = state.nextEl;
    state.topEl.classList.remove('vq-card--next');
    var after = state.deck[state.idx + 1];
    state.nextEl = null;
    if (after) {
      state.nextEl = buildCard(after);
      state.nextEl.classList.add('vq-card--next');
      stackEl.insertBefore(state.nextEl, stackEl.firstChild);
    }
    preload(state.idx + 2);
    updateProgress();
  }

  function undo() {
    if (state.busy || !state.answers.length) return;
    state.answers.pop();
    state.idx -= 1;
    renderStack();
  }

  function finish() {
    var liked = state.answers.filter(function (a) { return a.yes; }).map(function (a) { return a.id; });
    var no = state.answers.filter(function (a) { return !a.yes; }).map(function (a) { return a.id; });
    showResults(liked, no, true);
  }

  function resultUrl(liked, no) {
    var q = 'liked=' + liked.join(',') + (no.length ? '&no=' + no.join(',') : '');
    return location.origin + location.pathname + '?' + q;
  }

  function showResults(liked, no, pushUrl) {
    /* return earlier winners to the pool */
    while (gridEl.firstChild) poolEl.appendChild(gridEl.firstChild);
    var winners = pickWinners(liked, no);
    winners.forEach(function (p) { gridEl.appendChild(p.el); });
    chipsEl.innerHTML = '';
    var likedVibes = liked.map(function (id) { return VIBE_BY_ID[id]; }).filter(Boolean);
    if (!likedVibes.length) {
      var none = document.createElement('span');
      none.className = 'vq-chip';
      none.textContent = 'Nothing yet, so here are our favourites';
      chipsEl.appendChild(none);
    }
    likedVibes.forEach(function (v) {
      var c = document.createElement('span');
      c.className = 'vq-chip';
      c.textContent = v.title;
      chipsEl.appendChild(c);
    });
    copiedEl.textContent = '';
    state.result = { liked: liked, no: no };
    if (pushUrl && window.history && history.replaceState) {
      try { history.replaceState(null, '', resultUrl(liked, no)); } catch (e) { /* no-op */ }
    }
    showScreen('results');
  }

  function start() {
    state.deck = sampleDeck(Date.now());
    state.variant = (Date.now() >> 10) & 1;
    state.idx = 0;
    state.answers = [];
    state.busy = false;
    showScreen('cards');
    renderStack();
  }

  function copyLink() {
    var url = state.result ? resultUrl(state.result.liked, state.result.no) : location.href;
    var done = function () { copiedEl.textContent = 'Link copied'; setTimeout(function () { copiedEl.textContent = ''; }, 2500); };
    var fail = function () { copiedEl.textContent = url; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, fail);
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { fail(); }
      document.body.removeChild(ta);
    }
  }

  /* ---------------- Swipe (pointer events on the stack) ---------------- */
  var drag = null;
  stackEl.addEventListener('pointerdown', function (e) {
    if (state.busy || !state.topEl || e.button > 0) return;
    if (!state.topEl.contains(e.target)) return;
    drag = { x: e.clientX, y: e.clientY, dx: 0, id: e.pointerId };
    state.topEl.classList.add('is-dragging');
    try { stackEl.setPointerCapture(e.pointerId); } catch (err) { /* no-op */ }
  });
  stackEl.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id || !state.topEl) return;
    drag.dx = e.clientX - drag.x;
    var dy = e.clientY - drag.y;
    var rot = drag.dx / 18;
    state.topEl.style.transform = 'translate(' + drag.dx + 'px, ' + (dy * 0.25) + 'px) rotate(' + rot + 'deg)';
    var k = Math.min(Math.abs(drag.dx) / THRESHOLD, 1);
    var yes = state.topEl.querySelector('.vq-stamp--yes');
    var no = state.topEl.querySelector('.vq-stamp--no');
    if (yes) yes.style.opacity = drag.dx > 0 ? k : 0;
    if (no) no.style.opacity = drag.dx < 0 ? k : 0;
  });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var dx = drag.dx; drag = null;
    if (!state.topEl) return;
    try { stackEl.releasePointerCapture(e.pointerId); } catch (err) { /* no-op */ }
    if (Math.abs(dx) >= THRESHOLD) {
      answer(dx > 0);
    } else {
      state.topEl.classList.remove('is-dragging');
      state.topEl.style.transform = '';
      var yes = state.topEl.querySelector('.vq-stamp--yes');
      var no = state.topEl.querySelector('.vq-stamp--no');
      if (yes) yes.style.opacity = 0;
      if (no) no.style.opacity = 0;
    }
  }
  stackEl.addEventListener('pointerup', endDrag);
  stackEl.addEventListener('pointercancel', endDrag);

  /* ---------------- Controls ---------------- */
  $('[data-vq-start]').addEventListener('click', start);
  $('[data-vq-yes]').addEventListener('click', function () { answer(true); });
  $('[data-vq-no]').addEventListener('click', function () { answer(false); });
  undoBtn.addEventListener('click', undo);
  $('[data-vq-again]').addEventListener('click', function () {
    if (window.history && history.replaceState) {
      try { history.replaceState(null, '', location.pathname); } catch (e) { /* no-op */ }
    }
    start();
  });
  $('[data-vq-copy]').addEventListener('click', copyLink);

  document.addEventListener('keydown', function (e) {
    if (screens.cards.hidden) return;
    var tag = (e.target && e.target.tagName) || '';
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    if (e.key === 'ArrowRight') { e.preventDefault(); answer(true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); answer(false); }
    else if (e.key === 'Backspace') { e.preventDefault(); undo(); }
  });

  /* ---------------- Deep link ---------------- */
  function parseIds(v) {
    return (v || '').split(',').map(function (s) { return s.trim(); }).filter(function (id) { return VIBE_BY_ID[id]; });
  }
  var params = new URLSearchParams(location.search);
  var likedParam = parseIds(params.get('liked'));
  if (likedParam.length) {
    showResults(likedParam, parseIds(params.get('no')), false);
  }

  window.AzharaVibeQuiz = { pickWinners: pickWinners, sampleDeck: sampleDeck, answer: answer, start: start };
})();
